var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormClientNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0E3371",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19793_22932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8141 7.47679H8.40749C7.89386 7.47679 7.47705 7.05998 7.47705 6.54635V5.12868C7.47705 4.61505 7.89386 4.19824 8.40749 4.19824H13.8141C14.3277 4.19824 14.7446 4.61505 14.7446 5.12868V6.54635C14.7446 7.06061 14.3277 7.47679 13.8141 7.47679Z",
    fill: "#144BA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0661 14.2512C19.4877 13.6728 18.5447 13.6728 17.9663 14.2512L17.2798 14.9415L19.3808 17.0419L20.0661 16.3566C20.6507 15.7726 20.6507 14.8358 20.0661 14.2512Z",
    fill: "#144BA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6155 15.6084L12.9503 19.2673C12.8748 19.349 12.8245 19.4496 12.8057 19.5565L12.5291 21.1848C12.4662 21.5431 12.7805 21.8512 13.1389 21.7946L14.7671 21.518C14.874 21.4991 14.9746 21.4488 15.0501 21.3734L18.7152 17.7082L16.6155 15.6084Z",
    fill: "#144BA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.47 5.83887H15.6873V6.54613C15.6873 7.57904 14.8468 8.41958 13.8139 8.41958H8.40725C7.3737 8.41958 6.53379 7.57904 6.53379 6.54613V5.83887H5.73852C4.50002 5.83887 3.49414 6.84475 3.49414 8.08324V19.5566C3.49414 20.7951 4.50002 21.801 5.73852 21.801H11.6839C11.5884 21.5552 11.5525 21.2886 11.599 21.0227L11.875 19.3988C11.9241 19.1109 12.0561 18.8449 12.2547 18.628L16.2563 14.6322L17.2967 13.586C17.6834 13.1988 18.1794 12.9693 18.7131 12.9033V8.08953C18.7144 6.83846 17.7148 5.83887 16.47 5.83887ZM10.1317 15.164H7.40388C7.09143 15.164 6.83807 14.9107 6.83807 14.5982C6.83807 14.2858 7.09143 14.0324 7.40388 14.0324H10.1317C10.4442 14.0324 10.6975 14.2858 10.6975 14.5982C10.6975 14.9107 10.4442 15.164 10.1317 15.164ZM13.4712 11.9527H7.40451C7.09206 11.9527 6.8387 11.6994 6.8387 11.3869C6.8387 11.0745 7.09206 10.8211 7.40451 10.8211H13.4712C13.7837 10.8211 14.037 11.0745 14.037 11.3869C14.037 11.6994 13.7837 11.9527 13.4712 11.9527Z",
    fill: "#144BA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19793_22932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormClientNotes);
export default __webpack_public_path__ + "static/media/formClientNotes.d7d82a21bac55984b94c0206501a6fc6.svg";
export { ForwardRef as ReactComponent };